import { useEffect, useState } from 'react';

export function useGlobalFocusElement() {
  const [activeElement, setActiveElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const handleFocusIn = (e: FocusEvent) => {
      setActiveElement(e.target as HTMLElement);
    };

    document.addEventListener('focusin', handleFocusIn);

    setActiveElement(document.activeElement as HTMLElement | null);

    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return activeElement;
}
